

















import { Component, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Helpers
import { Meta } from '@/helpers/decorators'

// Mixins
import Errors from '@/mixins/Errors'

// Views
import ReportsList from '@/views/reports/list/ReportsList.vue'

@Component({
  components: {
    ReportsList
  }
})
export default class ListAllReports extends Mixins(Errors) {
  @Getter('token') token

  get itemTitle() {
    return this.$route.query.title
  }

  get itemID(): number {
    return parseInt(this.$route.params.id, 10)
  }

  deleteItem() {
    this.$dialog.confirm({
      title: this.$t('global.info_box.warning') as string,
      message: this.$t('item.actions.delete.message') as string,
      confirmText: this.$t('global.delete') as string,
      cancelText: this.$t('global.button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        try {
          const res = await this.$api.items.deleteItem(this.token, this.itemID)
          this.$router.push({ name: 'indexItems' })
          this.$toast.open({
            message: this.$t('item.delete.notification.success') as string,
            type: 'is-success',
            duration: 5000
          })
        } catch (error) {
          this.displayErrors(error)
        }
      }
    })
  }
}
